export interface MeSuccessResponse {
  me: {
    _type: string;
    id: string;
    email: string;
    fullname: string;
    images: any[];
  };
  organizations: Array<{
    _type: string;
    id: string;
    name: string;
    isDefault: boolean;
    keyName: string;
    defaultFacebookAppId: string;
    configIsVenueADeal: boolean;
    startOfDay: string;
  }>;
}

export const isMeSuccessResponse = (
  response: any | MeSuccessResponse
): response is MeSuccessResponse => {
  return response.me !== undefined;
};
